document.addEventListener("DOMContentLoaded", function() {


});


// Get all elements with class name "smooth_scroll"
const smooth_links = document.querySelectorAll('.smooth_scroll');

// Iterate over each smooth_scroll div
smooth_links.forEach((div) => {
    // Find all 'a' elements (href tags) inside the current div
    const hrefTags = div.querySelectorAll('a');
    
    // Iterate over each 'a' element
    hrefTags.forEach((a) => {
        // Get and log the href attribute
        a.addEventListener("click", clickHandler);
    });
});

function clickHandler (event) {
  event.preventDefault();
  const href = this.getAttribute("href");

  document.querySelector(href).scrollIntoView({
    behavior: "smooth"
  });
}

// Dynamically display current year in the footer
const yearElement = document.querySelector('.year'); 
const currentYear = new Date().getFullYear(); 

if ( yearElement ){
  yearElement.textContent = currentYear; 
}

